import { skipToken, useQuery } from '@tanstack/react-query';
import {
  getV1CompaniesCompanyIdApproveChargesSummary,
  GetV1CompaniesCompanyIdApproveChargesSummaryData,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { ApproveChargesSummary } from '~hooks/useApproveCharges/models';
import connection from '~services/connectionModule';

type ApproveChargesSummaryQuery =
  GetV1CompaniesCompanyIdApproveChargesSummaryData['query'];

export default function useApproveChargesSummaryQuery(
  companyId: string,
  query: ApproveChargesSummaryQuery,
  refreshToken: number,
) {
  const { data, isError, isLoading } = useQuery({
    queryKey: ['approveChargesSummary', companyId, query, refreshToken],
    queryFn: companyId
      ? async ({ signal }) => {
          try {
            const response = await getV1CompaniesCompanyIdApproveChargesSummary({
              path: { 'company-id': companyId },
              query,
              signal,
            });

            return ApproveChargesSummary.parse(response.data.data);
          } catch (error) {
            connection.handleRequestError(
              error,
              t('error_messages.approve_charges.failed_to_fetch_summary'),
            );
            throw error;
          }
        }
      : skipToken,
  });

  return { isError, isLoading, summary: data ?? null };
}
